import { useCurrencyVisibility } from '../../contexts/CurrencyVisibilityContext';
import './FloatingCurrency.css';

interface FloatingCurrencyProps {
  currency?: number;
}

export function FloatingCurrency({ currency }: FloatingCurrencyProps) {
  const { isVisible } = useCurrencyVisibility();

  return (
    <div className={`floating-currency ${isVisible ? 'floating-currency--visible' : ''}`}>
      <img src="/coin.png" alt="재화" className="floating-currency__icon" />
      <span className="floating-currency__value">
        {currency !== undefined ? currency.toLocaleString() : '0'}
      </span>
    </div>
  );
}

